import {tns} from 'tiny-slider';
import 'tiny-slider/dist/tiny-slider.css';

export default function initSliders(){
    const sliderElements=document.querySelectorAll('.image-slider-teaser-wrapper');

    sliderElements.forEach(sliderElement=>{
        const slider=tns({
            gutter: 5,
            autoWidth: true,
            nextButton: sliderElement.querySelector('.next'),
            prevButton: sliderElement.querySelector('.prev'),
            center: true,
            container: sliderElement.querySelector('.image-slider'),
            speed: 400,
            mouseDrag: true,
            swipeAngle: 60,
            responsive: {
                768: {
                    gutter: 20,
                },
            }
        });

        const sliderControlsElement=sliderElement.querySelector('.slider-controls');
        if(!sliderControlsElement) return;

        const currentItemInfoElement=sliderControlsElement.querySelector('.current');
        const totalItemsInfoElement=sliderControlsElement.querySelector('.total');

        currentItemInfoElement.innerHTML=slider.getInfo().displayIndex;
        totalItemsInfoElement.innerHTML=slider.getInfo().pages;


        slider.events.on('indexChanged', (info)=>{
            currentItemInfoElement.innerHTML=info.displayIndex;
        })
    })
}

